import { createPromiseAction } from 'redux-saga-promise-actions';
import { Ticket } from 'store/types';
import { TicketsResponse, TicketsPayload, CompaniesResponse } from 'store/types/tickets';

export const getAllTickets = createPromiseAction(
  'GET_ALL_TICKETS',
  'GET_ALL_TICKETS_SUCCEEDED',
  'GET_ALL_TICKETS_FAILURE',
)<TicketsPayload, Array<TicketsResponse>, undefined>();

export const getDetailsTicket = createPromiseAction(
  'GET_DETAILS_TICKET',
  'GET_DETAILS_TICKET_SUCCEEDED',
  'GET_DETAILS_TICKETS_FAILURE',
)<TicketsPayload, Array<TicketsResponse>, undefined>();

export const getCompanies = createPromiseAction('GET_COMPANIES', 'GET_COMPANIES_SUCCEEDED', 'GET_COMPANIES_FAILURE')<
  undefined,
  Array<CompaniesResponse>,
  undefined
>();
